import { render, staticRenderFns } from "./ProfessionalTeam.vue?vue&type=template&id=7d344343&scoped=true"
import script from "./ProfessionalTeam.vue?vue&type=script&lang=js"
export * from "./ProfessionalTeam.vue?vue&type=script&lang=js"
import style0 from "./ProfessionalTeam.vue?vue&type=style&index=0&id=7d344343&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d344343",
  null
  
)

export default component.exports